import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/price-history.module.css";
import moneyFormatter from "../../helper/moneyFormatter";

const Taxes = (props) => {
    const { listing } = props;

    if (!listing.taxes || !listing.taxes.length) {
        return <></>;
    }

    let i = 1;
    let taxes = [];

    for (let e of listing.taxes) {
        taxes.push(
            <tr key={"tax_" + i++}>
                <td className={css.textCenter}>{e["TaxYear"]}</td>
                <td className={css.textCenter}>{moneyFormatter(0).format(e["TaxAnnualAmount"])}</td>
                <td className={css.desc}>{e["TaxDescription"]}</td>
            </tr>
        );
    }

    return (
        <div className={css.priceHistory}>
            <table>
                <thead>
                    <tr>
                        <th className={css.textCenter}>Year</th>
                        <th className={css.textCenter}>Annual Amount</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>{taxes}</tbody>
            </table>
        </div>
    );
};

Taxes.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Taxes;
